import { create } from "zustand";
import { usePanelStore, type PanelFocus, type PanelView } from "./panel";
import { useChatStore } from "./chat";

type SendFn = (text: string) => void;

interface ChatActions {
  send: SendFn | null;
  register: (fn: SendFn) => void;
}

export const useChatActions = create<ChatActions>((set) => ({
  send: null,
  register: (fn) => set({ send: fn }),
}));

/**
 * Panel widgets call this to reveal something on the panel AND
 * fire a natural-language query to ripper about it (so the chat
 * stays in lockstep with what the operator is looking at).
 *
 * Only fires the LLM query when the chat is in listening mode —
 * otherwise just reveals (e.g. during the cinematic).
 */
export function askAboutAndReveal(
  prompt: string,
  view?: PanelView,
  focus?: PanelFocus
): void {
  if (view && focus) {
    usePanelStore.getState().reveal(view, focus);
  }
  const mode = useChatStore.getState().mode;
  if (mode !== "listening") return;
  const send = useChatActions.getState().send;
  if (send) send(prompt);
}
